// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container_3eNl0","center":"Card_center_34zHh"};